import React, { FC, useState } from 'react';
import { localeStore } from '~/mobx/localesStore';
import { MaskedInput } from '~/view/components/Controls/Inputs';
import Text from '~/view/components/Text/Text';

interface IProps {
  title: string;
  value: string;
  onChange: (value: string | undefined) => void;
}

const GoogleMapsKey: FC<IProps> = ({ title, value, onChange }): JSX.Element => {
  const [isFocused, setIsFocused] = useState<boolean>(false);
  const [hasInputValue, setHasInputValue] = useState(false);

  const handleFocus = () => setIsFocused(true);
  const handleBlur = () => setIsFocused(false);

  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Backspace' && !hasInputValue) {
      onChange('');
      setHasInputValue(true);
    }
  };

  const handleValueChange = (value: string | undefined) => {
    onChange(value);
    setHasInputValue(true);
  };

  return (
    <div className="d-flex align-items-center justify-content-between">
      <Text type="order-field" text={title} className="integration-settings__field w-40" />

      <MaskedInput
        value={isFocused && !hasInputValue ? '' : value}
        onChangeValue={handleValueChange}
        onFocus={handleFocus}
        onBlur={handleBlur}
        onKeyDown={handleKeyDown}
        placeholder={localeStore.t('Value')}
        className="flex-1"
        contentClassName="full-width"
      />
    </div>
  );
};

export default GoogleMapsKey;
